import type { DefaultResponseBody } from "@gerama/types";
import type { ApiClient } from "../client";

/** Mirrors `NotificationResponse` (`backend/libs/notifications/src/responses/notification.response.ts`). */
export interface InboxNotification {
  id: number;
  title: string;
  body: string | null;
  image: string | null;
  eventCode: string;
  refType: string | null;
  refId: number | null;
  deepLink: string | null;
  /** A copyable code (discount code…) the bell shows with a copy button. */
  code: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationInbox {
  list: { list: InboxNotification[]; count: number };
  unreadCount: number;
}

/** The signed-in listener's inbox (the header bell). */
export function createCoreNotificationsApi(client: ApiClient) {
  return {
    inbox: (params: { page?: number; limit?: number } = {}, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<NotificationInbox>>("/notifications", {
          query: { ...params },
          signal,
        })
        .then((res) => res.data ?? { list: { list: [], count: 0 }, unreadCount: 0 }),

    markRead: (id: number) =>
      client.request<DefaultResponseBody<InboxNotification>>(`/notifications/${id}/read`, {
        method: "POST",
      }),

    markAllRead: () =>
      client.request<DefaultResponseBody<null>>("/notifications/read-all", { method: "POST" }),
  };
}
